import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { isValid, format } from 'date-fns';
import get from 'lodash/get';
import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Image,
  Box,
  Text,
} from '@chakra-ui/react';
import VisibilityIcon from '@mui/icons-material/Visibility';

import CustomTable from '@/components/table/Table';
import { useGetActivities } from '@/customHooks/queries/activities/useGetActivities';
import { DATE_TIME_FULL_FORMAT } from '@/constants/common';
import { ITableData } from '@/components/table/Table.d';
import Pagination from '@/components/pagination/Pagination';

const ReportWrapperWeb = () => {
  const { sessionId } = useParams();
  console.log('sessionId ---->', sessionId);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentActivity, setCurrentActivity] = useState<any>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState(1);
  const {
    data: dataReports,
    refetch,
    isLoading,
  } = useGetActivities(sessionId, currentPage, true);

  const titleList = [
    'Id',
    'Session Id',
    'Evidence Type',
    'Time',
    'Note',
    'Image',
  ];
  const pathList = [
    'id',
    'sessionId',
    'activityType',
    'timestamp',
    'details',
    'action',
  ];

  const openModalEvident = (activityView: any) => {
    setCurrentActivity(activityView);
    onOpen();
  };

  const data = useMemo<ITableData[]>(() => {
    if (!dataReports || !Array.isArray(dataReports?.data.data)) return [];
    if (dataReports && dataReports.data?.meta) {
      setTotalPages(dataReports.data?.meta?.pageCount);
    }
    const reports = get(dataReports, 'data.data') || [];
    console.log('reports -->', reports);
    return reports.map((report: ITableData) => {
      return {
        ...report,
        timestamp: isValid(new Date(report.timestamp))
          ? format(new Date(report.timestamp), DATE_TIME_FULL_FORMAT)
          : '',
        action: (
          <div
            className="cursor-pointer"
            onClick={() => openModalEvident(report)}
          >
            <VisibilityIcon />
          </div>
        ),
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataReports, currentPage]);
  console.log('dataReports ---', dataReports);

  const handleOnClose = () => {
    setCurrentActivity(undefined);
    onClose();
  };

  console.log('Current activity => ', currentActivity);

  return (
    <Box mt="60px">
      <Button onClick={() => refetch()}>Refresh</Button>
      <Flex
        mt="12px"
        gap="8px"
        width="100%"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <CustomTable
          isLoading={isLoading}
          titleList={titleList}
          data={data}
          pathList={pathList}
        />
        <Pagination
          totalPages={totalPages}
          handleOnChange={(page) => setCurrentPage(page)}
          currentPage={currentPage}
        />
      </Flex>
      <Modal size="xl" isOpen={isOpen} onClose={handleOnClose}>
        <ModalOverlay />
        <ModalContent maxWidth="950px">
          <ModalHeader>Evidence: {currentActivity?.activityType}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text paddingBottom={10}>{currentActivity?.details}</Text>
            {!currentActivity?.activityType?.includes('Audio') ? (
              <Image alt="Evident-image" src={currentActivity?.image} />
            ) : (
              <div />
            )}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleOnClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default ReportWrapperWeb;
